export class ReporteParams {
  private today: Date = new Date();
  private startOfMonth: Date = new Date(this.today.getFullYear(), this.today.getMonth(), 1);
  
  fechaInicio: string = this.startOfMonth.toISOString().substring(0, 10);
  fechaFin: string = this.today.toISOString().substring(0, 10);
  nombreReporte: string = '';
  seccion: number = 0;
  coleccion?: number = 0;
  departamento?: number = 0;
  municipio?: number = 0;
  estado?: number = 0;
  TipoDocumento?: number;
  usuario?: number = 0;
  origen?: number = 0;
  formulario?: string = '';
}


export class BienesCulturalesReporte {
  fechaInicio: string
  fechaFin: string
  nombreReporte: string
  seccion:number
  coleccion?: number = 0;
  departamento?: number = 0;
  municipio?: number = 0;

  constructor(params: ReporteParams){
      this.fechaInicio= params.fechaInicio
      this.fechaFin= params.fechaFin
      this.seccion= params.seccion
      this.nombreReporte= params.nombreReporte
      this.coleccion= params.coleccion
      this.departamento= params.departamento
      this.municipio= params.municipio
  }

}

export class GestionesReporte {
  fechaInicio: string
  fechaFin: string
  nombreReporte: string
  seccion:number
  estado?: number = 0;
  origen?: number = 0;
  usuario?: number = 0;

  constructor(params: ReporteParams){
      this.fechaInicio= params.fechaInicio
      this.fechaFin= params.fechaFin
      this.nombreReporte= params.nombreReporte
      this.seccion= params.seccion
      this.estado= params.estado
      this.origen= params.origen
      this.usuario= params.usuario
  }

}

export class SolicitudesReporte {
  fechaInicio: string
  fechaFin: string
  nombreReporte: string
  seccion:number
  estado: number = 0;
  formulario: string | number;
  usuario: number = 0;

  constructor(params: ReporteParams){
      this.fechaInicio= params.fechaInicio
      this.fechaFin= params.fechaFin
      this.nombreReporte= params.nombreReporte
      this.seccion= params.seccion
      this.estado= params.estado
      this.formulario= params.TipoDocumento
      this.usuario= params.usuario
  }

}

export class DocumentosOficialesReporte {
  fechaInicio: string
  fechaFin: string
  nombreReporte: string
  seccion:number
  estado: number;
  TipoDocumento?: number;
  usuario?: number;

  constructor(params: ReporteParams){
      this.fechaInicio= params.fechaInicio
      this.fechaFin= params.fechaFin
      this.nombreReporte= params.nombreReporte
      this.seccion= params.seccion
      this.estado= params.estado
      this.TipoDocumento= params.TipoDocumento
      this.usuario= params.usuario
  }

}